export default __webpack_public_path__ + "static/vegetarian-3e243f04fc3b0673b17ea54270711ef6.svg";